import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/isolated/Button';
import { ModalFooter } from '~/components/Modal/components/ModalFooter';
import { useGlobal } from '~/hooks/useGlobal';

import { ValidationTooltip } from '../ValidationTooltip';

import styles from './ButtonSubmit.module.scss';
import { BottomSubmitProps } from './interfaces';

const BottomSubmit = ({
  shouldSplitSlot,
  handleSelectSlot,
  handleSplit,
  selectedSlotId,
  handleCloseModal,
}: BottomSubmitProps) => {
  const { isMobile } = useGlobal();
  const { t } = useTranslation();

  const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const handleClick = () => {
    if (!selectedSlotId) {
      setTooltipOpen(true);
      return;
    }

    const handler = shouldSplitSlot ? handleSplit : handleSelectSlot;
    handler();
  };

  const handleCloseTooltip = () => {
    setTooltipOpen(false);
  };

  useEffect(() => {
    if (selectedSlotId) {
      setTooltipOpen(false);
    }
  }, [selectedSlotId]);

  if (!isMobile) {
    return (
      <div className={styles.root}>
        <ValidationTooltip
          title={t('selectTimeSlot')}
          open={isTooltipOpen}
          onClose={handleCloseTooltip}
        >
          <Button
            variant="primary"
            className={styles.submitBtn}
            onClick={handleClick}
          >
            {t('deliverByThisTime')}
          </Button>
        </ValidationTooltip>
      </div>
    );
  }

  return (
    <ModalFooter
      onBack={handleCloseModal}
      primaryAction={{
        text: t('confirm'),
        onClick: handleClick,
      }}
      validationTooltip={{
        show: isTooltipOpen,
        message: t('selectTimeSlot'),
        onClose: handleCloseTooltip,
      }}
    />
  );
};

export default BottomSubmit;
